module.exports = {"username":"Gebruikersnaam","password":"Wachtwoord","login":"Inloggen","errors":{"username-required":"Gebruikersnaam is verplicht en mag niet leeg zijn","password-required":"Wachtwoord is verplicht en mag niet leeg zijn","4c6e7474-1892-43f3-baf9-b8a8b9ea2be5":"Gebruikersnaam of wachtwoord niet gevonden"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/login-form.json
// module id = FDJ4
// module chunks = 1